import type { ReactNode } from 'react';
import { Grid, Text } from '@simplywallst/ui-core';
import { KeyMetric } from '@/components/KeyMetric';
import { toCurrencyTruncated } from '@/utilities/formatting';

import { Narrative } from '@/pages/PublicNarrativeAuthoring/hooks/useNarrativeById';
import { FairValueContainer } from './styled';

interface Props {
  fairValue: Narrative['valuations'][number]['fairValue'];
  valuationByLine: Narrative['valuations'][number]['valuationByLine'];
  valuatorToolLink?: Narrative['valuations'][number]['valuatorToolLink'];
  currencyISO: string;
  title?: string;
  children?: ReactNode;
}

export const FairValue = ({
  title,
  fairValue,
  currencyISO,
  valuationByLine,
  children,
}: Props) => {
  return (
    <FairValueContainer gap="16px">
      <Grid
        templateColumns="max-content max-content"
        justifyContent="space-between"
      >
        <Text typography="tinyStrong" color="whiteRGBA" opacity={0.5}>
          {title || 'Fair value'}
        </Text>
      </Grid>
      <KeyMetric>
        <Grid
          gap="12px"
          templateColumns="max-content max-content"
          alignItems="center"
        >
          <Text
            typography="megaStrong"
            color="white"
            data-cy-id="narrative-fair-value-valuation"
          >
            {toCurrencyTruncated(fairValue, 1, currencyISO)}
          </Text>
        </Grid>
        <Grid templateColumnsMd="295px" templateColumns="342px">
          <Text
            typography="xSmall"
            color="whiteRGBA"
            opacity={0.7}
            data-cy-id="narrative-fair-value-by-line"
          >
            {valuationByLine || ''}
          </Text>
        </Grid>
      </KeyMetric>
      {children}
    </FairValueContainer>
  );
};
